import { connect } from 'react-redux'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../Icons'
import { selectUserData } from '../../reducers/userDataReducer'
import { getBuildingTimezoneFromEvent, getFormattedDate, getDates } from '../../helpers/helpers'
import { MINUTE } from '../../helpers/constants'
import { MonthTimeBlock } from './TimeBlocks/MonthTimeBlock'

const MonthReservationEvent = (props) => {
  const { t } = useTranslation(['calendar'])
  const {
    title,
    locationName,
    date,
    startTime,
    endTime,
    endDate,
    canceled,
    client,
    guest,
    isWeeklySlot,
    reservationType,
  } = props.event
  const startWithHours = endDate || date + startTime * MINUTE
  const endWithHours = date + (endTime || 0) * MINUTE
  const timezone = getBuildingTimezoneFromEvent(props.event)

  const isCompleted = moment().tz(timezone).isAfter(moment(startWithHours).tz(timezone, true))
  let eventClass = 'ctp-event'
  if (isCompleted || canceled) {
    eventClass += ' ctp-event--archive'
  }
  if (moment(startWithHours).format('DD-MM-YYYY') === moment(new Date()).format('DD-MM-YYYY')) {
    eventClass += ' ctp-event--today'
  }
  if (reservationType === 'blockedDay') {
    eventClass = 'ctp-event ctp-event--blocked'
  }

  const getReservationTypeInfo = (reservationType, { startWithHours, endWithHours }, timezone) => {
    switch (reservationType) {
      case 'phantomBooking':
        return (
          <div className="ctp-reservation-event__phantom-booking">
            {t('calendar:reservationTypes.phantomBooking')}
          </div>
        )
      case 'unavailableSlot':
        return (
          <div>
            <div className="ctp-reservation-event__phantom-booking">
              {t('calendar:reservationTypes.unavailableSlot')}
              {isWeeklySlot ? (
                <div className="ctp-reservation-event__unavailable-slot-icon">
                  <Icon icon="circleArrows" viewBox="0 0 10 10" />
                </div>
              ) : null}
            </div>
            <div className="ctp-reservation-event__unavailable-slot-time">
              {moment(startWithHours)
                .tz(timezone || 'America/Chicago')
                .format('DD MMMM, hh:mm A')}
              -
              {moment(endWithHours)
                .tz(timezone || 'America/Chicago')
                .format('hh:mm A')}
            </div>
          </div>
        )

      default:
        return null
    }
  }

  if (reservationType === 'timeBlock') {
    return (
      <div className={eventClass}>
        <MonthTimeBlock timeBlock={props.event} timezone={timezone} />
      </div>
    )
  }

  return (
    <div className={eventClass}>
      {reservationType && reservationType !== 'reservation' ? (
        <div className="ctp-reservation-event__inner" style={{ backgroundColor: '#EAEAEA' }}>
          {getReservationTypeInfo(
            reservationType,
            {
              startWithHours,
              endWithHours,
            },
            timezone,
          )}
        </div>
      ) : (
        <div className="ctp-reservation-event__inner" style={{ backgroundColor: '#f0efef' }}>
          <div className="ctp-reservation-event__main-info">
            {locationName ? locationName : title}{' '}
            {client
              ? `${client.firstName} ${client.lastName}`
              : `${guest.firstName} ${guest.lastName}`}
          </div>
          {endDate ? (
            <time className="ctp-reservation-event__time">{getDates(props.event, timezone)}</time>
          ) : (
            <time className="ctp-reservation-event__time">
              {getFormattedDate(startWithHours, timezone)}-
              {getFormattedDate(endWithHours, timezone)}
            </time>
          )}
        </div>
      )}
    </div>
  )
}

MonthReservationEvent.propTypes = {
  event: PropTypes.object,
  userData: PropTypes.object,
}

export default connect((state) => ({ userData: selectUserData(state) }))(MonthReservationEvent)
